import React, { useEffect, useState } from "react";
import "../About/About.css";
import image from "../Assets/tech-1.png";
import image2 from "../Assets/facilities-1.png";
import { Link } from "react-router-dom";
import Mission from "../Mission/Mission";

function About() {
  const [btnShow, setBtnShow] = useState(true);

  useEffect(() => {
    if (window.location.pathname === "/about") {
      setBtnShow(false);
    }
  }, []);

  return (
    <>
      <div className="about">
        <div className="approved">
          <span>
            "State of the art WHO-GMP, ISO 9001:2008 and NPCB, PIC/S Malaysia
            approved manufacturing facility."
          </span>
        </div>
        <div className="about-main-comp">
          <div className="left-side">
            <h1 className="about-title"> About Us </h1>
            <p className="intro-company">
              Medisol Lifescience Pvt. Ltd. is a pharmaceutical manufacturing
              unit located at Aklara, Tal. Umargam Dist.Valsad (Gujarat), India.
              It is WHO-GMP Certified Plant.
              <br />
              <br /> Medisol Lifescience Pvt. Ltd. is a unit of Asian Aerosol
              group of companies with factories located at Vapi (Gujarat), Daman
              (Union Territory) and Kishanpura (Himachal Pradesh) with central
              corporate and branch offices at Mumbai whose core competency is
              Aerosol spray.
              <br />
              <br /> The operations are professionally managed manufacturing of
              asthmatic Inhalers for asthma patients. We are having technical
              trained and highly qualified, self motivated employees for
              building the strength of our productivity.
              <br />
              <br />
              We are world class manufacturer of Pressurized Metered Dose
              Inhalers (pMDI). We have proven, market – leading expertise in
              Inhalers Manufacturing Technology. We have WHO-GMP, ISO 9001:2008
              and NPRA, PIC/S Malaysia Approved dedicated & State-of-Art.
              manufacturing facility for Pressurized Metered Dose Inhalers
              (pMDI). Our Product Range Covers: Anti-Asthmatics and Chronic
              Obstructive Pulmonary Diseases Formulations.
            </p>

            {btnShow && (
              <Link to="/about" className="btn-readmore">
                Read More{" "}
              </Link>
            )}
          </div>
          <div className="right-side">
            <div className="right-side-image">
              <img src={image} alt="" className="about-image" />
            </div>
            <div>
              <img src={image2} alt="" className="about-image" />
            </div>
          </div>
        </div>
      </div>
      <div>{!btnShow && <Mission />}</div>
    </>
  );
}
export default About;
